import { NOTIFICATION_TYPE } from 'constant';

export const Notification = (props = {
  action: undefined,
  message: undefined,
  type: undefined,
  data: undefined,
}) => ({ type: NOTIFICATION_TYPE.ERROR, ...props });
